const enum Cashback {
  WITH_SUBSCRIPTION = 10,
  WITHOUT_SUBSCRIPTION = 5,
}

export const calculateSum = (halvaDesyatka: boolean, spending: number) => {
  const cashbackRate = halvaDesyatka ? Cashback.WITH_SUBSCRIPTION : Cashback.WITHOUT_SUBSCRIPTION
  const cashbackAmount = Math.floor((spending / 100) * cashbackRate)
  const maxCashback = halvaDesyatka ? 5000 : 3000

  return Math.min(cashbackAmount, maxCashback)
}
